import {
  Box,
  CardContent,
  Divider,
  Paper,
  Card,
  CardHeader
} from '@material-ui/core';
import React from 'react';
import { Line } from 'react-chartjs-2';

function DashboardGraph({ failedSummary, successSummary }) {
  let successData;
  let failedData;
  if (successSummary) {
    successData = successSummary.map(item => item.val);
    failedData = failedSummary.map(item => item.val);
  }

  const data = {
    labels: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec'
    ],
    datasets: [
      {
        data: successData,
        // data: [65, 59, 80, 81, 56, 55, 40],
        label: 'Successful Request',
        fill: false,
        // backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,50,192,1)'
      },
      {
        data: failedData,
        // data: [45, 19, 90, 31, 86, 35, 40],
        label: 'Failed Request',
        fill: false,
        // backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)'
      }
    ]
  };

  const options = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            min: 0
          }
        }
      ]
    }
  };
  return (
    <Card>
      <CardHeader title="API Requests" />
      <Divider />
      <CardContent>
        <Box position="relative">
          <Line data={data} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
}

export default DashboardGraph;
